import { render, staticRenderFns } from "./StaffWhoMadeMostRound.vue?vue&type=template&id=1e32c520&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/StaffWhoMadeMostRound.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/StaffWhoMadeMostRound.js?vue&type=script&lang=js&external"
import style0 from "./StaffWhoMadeMostRound.vue?vue&type=style&index=0&id=1e32c520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32c520",
  null
  
)

export default component.exports